module.exports = __webpack_public_path__ + "img/play1.da603fcc.png";